// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"DependenciesPublishNote_loaderWrapper__IdDNH","loaderText":"DependenciesPublishNote_loaderText__zkMMn","root":"DependenciesPublishNote_root__DhL8y"};